

import { motion } from "motion/react"

const empresas = [
    "/img/convenios/1.png",
    "/img/convenios/2.png",
    "/img/convenios/3.png",
    "/img/convenios/4.png",
    "/img/convenios/5.png",
    "/img/convenios/6.png",
]

const ConveniosCarousel = () => {
    return (
        <>
            <p className="text-center titulo-convenios mx-0 px-0 py-2">ALGUNOS DE NUESTROS CONVENIOS</p>
            <div className="carousel-wrapper">

                {/* BLUR IZQUIERDA */}
                <div className="blur-edge left" />
                {/* BLUR DERECHA */}
                <div className="blur-edge right" />

                <motion.div
                    className="carousel-track"
                    animate={{ x: ["0%", "-50%"] }}
                    transition={{
                        repeat: Infinity,
                        duration: 60,
                        ease: "linear",
                    }}
                >
                    {[...empresas, ...empresas].map((logo, i) => (
                        <img key={i} src={logo} className="logo-convenio" />
                    ))}
                </motion.div>
            </div>
        </>
    )
}

export default ConveniosCarousel